module.exports = __webpack_public_path__ + "static/media/new.dd4ad2c9.svg";